import { useState } from 'react';
import { Users, FileStack, LayoutGrid, Gauge } from 'lucide-react';
import GeneralTab from './planificacio/GeneralTab';
import ResourcesTab from './planificacio/ResourcesTab';
import ResourceViewTab from './planificacio/ResourceViewTab';
import TemplatesTab from './planificacio/TemplatesTab';

// Mòdul "Planificació General" — nou i independent del Gantt de
// taller/Planificacio.tsx i del Cronograma de l'expedient
// (Project.cronogramaLines). Vegeu el backlog del mòdul per al disseny.
// La pestanya "Cronograma" (vista d'un sol expedient, ScheduleTab.tsx) s'ha
// eliminat (2026-11-03): era redundant amb "Planificació General", que ja
// mostra totes les fases amb capítols expandibles. Les fases ara es
// sincronitzen automàticament des del Cronograma de cada expedient
// (vegeu planningSync.service.ts) en lloc d'importar-se manualment.
const tabs = [
  { id: 'general', label: 'Planificació General', icon: LayoutGrid, color: 'purple' },
  { id: 'recursos-vista', label: 'Càrrega de Recursos', icon: Gauge, color: 'amber' },
  { id: 'recursos', label: 'Recursos', icon: Users, color: 'green' },
  { id: 'plantilles', label: 'Plantilles', icon: FileStack, color: 'teal' },
];

const COLOR: Record<string, { border: string; icon: string; iconBg: string }> = {
  purple: { border: 'border-purple-500', icon: 'text-purple-500', iconBg: 'bg-purple-500/10' },
  amber:  { border: 'border-amber-500',  icon: 'text-amber-500',  iconBg: 'bg-amber-500/10' },
  green:  { border: 'border-green-500',  icon: 'text-green-500',  iconBg: 'bg-green-500/10' },
  teal:   { border: 'border-teal-500',   icon: 'text-teal-500',   iconBg: 'bg-teal-500/10' },
};

export default function PlanificacioGeneral() {
  const [activeTab, setActiveTab] = useState('general');

  const renderContent = () => {
    switch (activeTab) {
      case 'general': return <GeneralTab />;
      case 'recursos-vista': return <ResourceViewTab />;
      case 'recursos': return <ResourcesTab />;
      case 'plantilles': return <TemplatesTab />;
      default: return null;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Planificació General</h1>
        <p className="text-gray-600 mt-2">Fases, recursos i assignacions de tots els expedients</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const c = COLOR[tab.color];
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-3.5 py-2 rounded-lg border text-xs font-medium transition-colors ${
                isActive ? `${c.border} ${c.iconBg} text-gray-900` : 'border-gray-200 text-gray-600 hover:bg-gray-50'
              }`}
            >
              <Icon size={15} className={isActive ? c.icon : 'text-gray-400'} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {renderContent()}
    </div>
  );
}
